import React, { useEffect, useState } from 'react';
import './carousel.scss';

type IProps = {
  children: React.ReactNode;
  duration?: number;
  setParentIndex?: React.Dispatch<React.SetStateAction<{ index: number }>>;
};

export default function Carousel(props: IProps) {
  const { children, duration = 5000, setParentIndex } = props;
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  useEffect(() => {
    const interval = setInterval(() => handleScroll(), duration);
    return () => clearInterval(interval);
  });

  function handleScroll() {
    const childrenLength =
      React.Children?.toArray(children)?.filter(
        (filteredChild) => filteredChild != null,
      )?.length - 1;
    //Send to first child if current index is at the end
    if (currentIndex === childrenLength) {
      if (setParentIndex) {
        setParentIndex({ index: 0 });
      }
      setCurrentIndex(0);
    } else {
      if (setParentIndex) {
        setParentIndex({ index: currentIndex + 1 });
      }
      setCurrentIndex((prev) => prev + 1);
    }
  }

  return (
    <div className="ui-carousel-container">
      {React.Children?.count(children) > 0
        ? React.Children?.toArray(children)
            ?.filter((filteredChild) => filteredChild != null)
            ?.map((child, index) => {
              return (
                <div
                  className="ui-carousel-item"
                  key={index}
                  style={{ transform: `translate(-${currentIndex * 100}%)` }}
                >
                  {child}
                </div>
              );
            })
        : null}
    </div>
  );
}
